import { render, staticRenderFns } from "./EquipmentModelManage.vue?vue&type=template&id=28c0104a"
import script from "./EquipmentModelManage.vue?vue&type=script&lang=js"
export * from "./EquipmentModelManage.vue?vue&type=script&lang=js"
import style0 from "./EquipmentModelManage.vue?vue&type=style&index=0&id=28c0104a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports